import { createContext, useContext } from 'react'

import { defaultTheme, Theme } from '@/constants/theme'

export type ThemeProviderState = {
  theme: Theme
  setTheme: (theme: Theme) => void
}

const initialState: ThemeProviderState = {
  theme: defaultTheme,
  setTheme: () => null
}

export const ThemeProviderContext =
  createContext<ThemeProviderState>(initialState)

const useTheme = () => {
  const context = useContext(ThemeProviderContext)

  if (context === undefined)
    throw new Error('useTheme must be used within a ThemeProvider')

  return context
}

export default useTheme
